import { isAnyCarsVehiclesCategory } from '@kijiji/category'
import { type FilterGroup } from '@kijiji/generated/graphql-types'

import { FILTER_CANONICAL } from '@/constants/search'

const { CATEGORY_SECTION, PRICE_SECTION, LOCATION_SECTION, ADTYPE_SECTION } = FILTER_CANONICAL

export const getQuickFilters = (filters: FilterGroup[], selectedCategoryId: number) => {
  if (!filters.length) return []

  const MAX_QUICK_FILTERS = isAnyCarsVehiclesCategory(selectedCategoryId) ? 7 : 5

  const excludedSections: string[] = [ADTYPE_SECTION]

  const quickFilterGroups = [...filters]
    .filter(({ name }) => !excludedSections.includes(name))
    .sort((a, b) => {
      // Location should be first if it is included
      if (b.name === LOCATION_SECTION) return 1
      if (a.name === LOCATION_SECTION) return -1

      // Category should be second
      if (b.name === CATEGORY_SECTION) return 1
      if (a.name === CATEGORY_SECTION) return -1

      // Price should be third
      if (b.name === PRICE_SECTION) return 1
      if (a.name === PRICE_SECTION) return -1

      if (!a.quickFilterSortOrder && b.quickFilterSortOrder) return 1
      if (a.quickFilterSortOrder && !b.quickFilterSortOrder) return -1

      if (a.quickFilterSortOrder && b.quickFilterSortOrder) {
        return a.quickFilterSortOrder - b.quickFilterSortOrder
      }

      return 0
    })
    .slice(0, MAX_QUICK_FILTERS)

  const quickFilters = quickFilterGroups.flatMap((group) => group.filters)

  return quickFilters.slice(0, MAX_QUICK_FILTERS)
}
